import styled from "styled-components";
import Layout from "../components/Layout";
import CreateTransaction from "../components/_CreateTransaction";

const MainContainer2 = styled.div`
  padding-top: 32px;
  padding-left: 25px;
  padding-right: 10px;
`

const CreateTransactionPage = (props: any) => <Layout>
  <MainContainer2>
    <CreateTransaction />
  </MainContainer2>
</Layout>
export default CreateTransactionPage